import * as React from 'react';
import LinearProgress, {
  LinearProgressProps,
} from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

type SparkProgressBarProps = {
  value: number;
  renderPercentage?: boolean;
} & LinearProgressProps;

export default function SparkProgressBar({
  value,
  renderPercentage = true,
  ...props
}: SparkProgressBarProps) {
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant='determinate' {...props} value={value} />
        </Box>
        {renderPercentage && (
          <Box sx={{ minWidth: 35 }}>
            <Typography variant='body2' color='text.secondary'>{`${Math.round(
              value
            )}%`}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
